import { __decorate, __extends } from "tslib";
import { CustomElement, attachShadowTemplate, upgradeProperty } from '@tyler-components-web/core';
import { tylIconCancel } from '@tylertech/tyler-icons/standard';
import { ChipAdapter } from './chip-adapter';
import { ChipFoundation } from './chip-foundation';
import { CHIP_CONSTANTS } from './chip-constants';
import { TylerIconRegistry, IconComponent } from '../../icon';
var template = require('./chip.html');
var styles = require('./chip.css');
/**
 * The custom element class behind the `<tcw-chip>` component.
 */
var ChipComponent = /** @class */ (function (_super) {
    __extends(ChipComponent, _super);
    function ChipComponent() {
        var _this = _super.call(this) || this;
        TylerIconRegistry.define(tylIconCancel);
        attachShadowTemplate(_this, CHIP_CONSTANTS.elementName, template, styles);
        _this._foundation = new ChipFoundation(new ChipAdapter(_this));
        return _this;
    }
    Object.defineProperty(ChipComponent, "observedAttributes", {
        get: function () {
            return [
                CHIP_CONSTANTS.attributes.TYPE,
                CHIP_CONSTANTS.attributes.SELECTED,
                CHIP_CONSTANTS.attributes.DISABLED,
                CHIP_CONSTANTS.attributes.VALUE,
                CHIP_CONSTANTS.attributes.DENSE,
                CHIP_CONSTANTS.attributes.INVALID,
            ];
        },
        enumerable: true,
        configurable: true
    });
    ChipComponent.prototype.initializedCallback = function () {
        upgradeProperty(this, 'type');
        upgradeProperty(this, 'selected');
        upgradeProperty(this, 'disabled');
        upgradeProperty(this, 'invalid');
        upgradeProperty(this, 'value');
        upgradeProperty(this, 'dense');
    };
    ChipComponent.prototype.connectedCallback = function () {
        this._foundation.initialize();
    };
    ChipComponent.prototype.disconnectedCallback = function () {
        this._foundation.disconnect();
    };
    ChipComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        switch (name) {
            case CHIP_CONSTANTS.attributes.TYPE:
                this.type = newValue;
                break;
            case CHIP_CONSTANTS.attributes.SELECTED:
                this.selected = this.hasAttribute(CHIP_CONSTANTS.attributes.SELECTED);
                break;
            case CHIP_CONSTANTS.attributes.DISABLED:
                this.disabled = this.hasAttribute(CHIP_CONSTANTS.attributes.DISABLED);
                break;
            case CHIP_CONSTANTS.attributes.INVALID:
                this.invalid = this.hasAttribute(CHIP_CONSTANTS.attributes.INVALID);
                break;
            case CHIP_CONSTANTS.attributes.VALUE:
                this.value = newValue;
                break;
            case CHIP_CONSTANTS.attributes.DENSE:
                this.dense = this.hasAttribute(CHIP_CONSTANTS.attributes.DENSE);
                break;
        }
    };
    Object.defineProperty(ChipComponent.prototype, "type", {
        /** Gets/sets the chip type. */
        get: function () {
            return this._foundation.type;
        },
        set: function (value) {
            this._foundation.type = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChipComponent.prototype, "selected", {
        /** Gets/sets the selected state of the chip. */
        get: function () {
            return this._foundation.selected;
        },
        set: function (value) {
            this._foundation.selected = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChipComponent.prototype, "disabled", {
        /** Gets/sets the disabled state of the chip. */
        get: function () {
            return this._foundation.disabled;
        },
        set: function (value) {
            this._foundation.disabled = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChipComponent.prototype, "invalid", {
        /** Gets/sets the invalid state of the chip. */
        get: function () {
            return this._foundation.invalid;
        },
        set: function (value) {
            this._foundation.invalid = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChipComponent.prototype, "value", {
        /** Gets/sets the chip value. */
        get: function () {
            return this._foundation.value;
        },
        set: function (value) {
            this._foundation.value = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChipComponent.prototype, "dense", {
        /** Gets/sets the dense state of the chip. */
        get: function () {
            return this._foundation.dense;
        },
        set: function (value) {
            this._foundation.dense = value;
        },
        enumerable: true,
        configurable: true
    });
    ChipComponent.prototype.focus = function () {
        this._foundation.setFocus();
    };
    ChipComponent = __decorate([
        CustomElement({
            name: CHIP_CONSTANTS.elementName,
            dependencies: [IconComponent]
        })
    ], ChipComponent);
    return ChipComponent;
}(HTMLElement));
export { ChipComponent };
